import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { useCourseStore } from './CourseStore'
import { useGolferStore } from './GolferStore'
import { useRoundStore } from './RoundStore'

export const useMetaStore = create()(
  persist(
    (set, get) => ({
      apiKey: get()?.apiKey || '',
      setApiKey: (apiKey) => set({ apiKey }),
      orgId: get()?.orgId || '',
      setOrgId: (orgId) => set({ orgId }),
      eventId: get()?.eventId || '',
      setEventId: (eventId) => set({ eventId }),
      pageTitle: get()?.pageTitle || '',
      setPageTitle: (pageTitle) => set({ pageTitle }),
      errorMsg: '',
      setErrorMsg: (errorMsg) => set({ errorMsg }),
      finalized: get()?.finalized || false,
      setFinalized: (finalized) => set({ finalized }),
      adminEntry: get()?.adminEntry || false,
      setAdminEntry: (adminEntry) => set({ adminEntry }),
      isAdmin: get()?.isAdmin || false,
      setIsAdmin: (isAdmin) => set({ isAdmin }),
      globalModal: { show: false, message: '', color: '#060' },
      setGlobalModal: (show, message, color) => set({ globalModal: { show, message, color } }),
      closeGlobalModal: () => set((state) => ({ globalModal: { ...state.globalModal, show: false } })),
      validateLogin: () => {
        const course = useCourseStore.getState().course

        if (!get()?.apiKey || !course) {
          return false
        } else {
          return true
        }
      },
      initRound: async () => {
        useRoundStore.getState().setRoundHoleCount(9)
        useRoundStore.getState().setHoleNum(1)
        useGolferStore.getState().setGroup([])
        useGolferStore.getState().setGroupRounds([])
        useGolferStore.getState().setGolfers([])
        useGolferStore.getState().setRoundGolferMap({})
      },
      logout: async () => {
        useMetaStore.getState().initRound()
        useRoundStore.getState().setRoundDate(null)
        useMetaStore.getState().setApiKey(null)
        useMetaStore.getState().setPageTitle('')
        useMetaStore.getState().setIsAdmin(false)
        useMetaStore.getState().setFinalized(false)
        useMetaStore.getState().setOrgId('')
        useMetaStore.getState().setAdminEntry(false)
        useMetaStore.getState().setEventId('')
        document.cookie = 'gsk_player_login=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
      },
    }),
    {
      name: 'gsk-meta',
      storage: createJSONStorage(() => localStorage),
    }
  )
)

export const getPlayerNameFromCookie = () => {
  try {
    const value = `; ${document.cookie}`
    const parts = value.split(`; gsk_player_login=`)
    if (parts.length === 2) {
      const cookieVal = parts.pop().split(';').shift()
      try {
        const loginData = JSON.parse(decodeURIComponent(cookieVal))
        if (loginData?.golferName) return loginData.golferName
      } catch (e) {
        const loginData = JSON.parse(cookieVal)
        if (loginData?.golferName) return loginData.golferName
      }
    }
  } catch (err) {
    console.error('Failed to parse player login cookie', err)
  }
  return null
}
